module.exports = __webpack_public_path__ + "static/media/logo.b38312f8.png";